module.exports = __webpack_public_path__ + "img/bracket-14.f6992161.svg";